declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/** Push a GTM dataLayer event. No-op (never throws) if GTM hasn't loaded yet. */
export function pushDataLayerEvent(event: string, params?: Record<string, unknown>): void {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch {
    // ignore — analytics must never break the app
  }
}
